import gql from "graphql-tag";

/**
 * Used here only to record a reported problem against an order.
 *
 * NEVER send `items` from the tech app. An empty array deletes every item on the
 * order, and any array at all re-runs the backend's jobItem reconciliation, which
 * rewires the links between part items and the job's service lines. Omitting the key
 * leaves both untouched.
 */
export const UPDATE_PART_ORDER = gql`
  mutation updatePartOrder($id: ID!, $updatePartOrderInput: UpdatePartOrderInput!) {
    updatePartOrder(id: $id, updatePartOrderInput: $updatePartOrderInput) {
      id
      partOrderingIssue
      partOrderingIssueNotes
    }
  }
`;
